import styled from 'styled-components/macro';

import { baseSpacing } from 'css/constants';
import { H3 } from '@sohonet/ui-components/Typography';

export const SectionTitle = styled(H3)`
  margin: ${baseSpacing / 2}px 0 0 0;
`;
